import { useState } from 'react';
import { TextField, Alert, MenuItem, Button } from '@mui/material';
import ModalForm from '../../Tools/ModalForm';
import API from '../../../services/API.js';
import { useQuery } from 'react-query';

export default function EnrollButton({ userId, onEnroll, label = 'Inscrire', buttonProps = {} }){

    const { data: courses = [] } = useQuery({
        queryKey: ['company', 'courses'],
        queryFn: async () => {
            const response = await API.get('/companies/me/courses');
            return response.data;
        },
    });

    const { data: users = [] } = useQuery({
        queryKey: ['company', 'users'],
        queryFn: async () => {
            const response = await API.get('/companies/me/users');
            return response.data;
        },
        enabled: !userId,
    });

    const [openModal, setOpenModal] = useState(false);

    const toggleModal = () => setOpenModal(!openModal);

    const [values, setValues] = useState({
        userId: '',
        courseId: '',
    })

    const [error, setError] = useState(false);

    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        let newValues = {...values};
        newValues[name] = value;
        return setValues(newValues);
    }

    const handleSubmit = e => {
        e.preventDefault();

        if( !isValid() ) return false;

        const data = {
            user: { id: userId || values.userId },
            course: { id: values.courseId },
            type: { id: 'standard' },
            amount: 0,
        };

        API.post(`/companies/me/enrollments`, data)
            .then(r => handleSuccess(r.data))
            .catch(e => handleError(e))

        return setLoading(true);
    }

    const handleSuccess = data => {
        setLoading(false);
        setValues({ userId: '', courseId: '' });
        toggleModal();
        onEnroll(data);
    }

    const handleError = e => {
        console.log(e);
        setLoading(false);
        if(e.response?.status === 409) return setError("Cet utilisateur est déjà inscrit à cette formation.");
        return setError("Une erreur s'est produite. Vérifier que l'utilisateur n'est pas déjà inscrit à cette formation.");
    }

    const isValid = () => {
        let e = false;
        if(!userId && !values.userId) e = 'Veuillez sélectionner un utilisateur.';
        if(!values.courseId) e = 'Veuillez sélectionner une formation.';
        setError(e);
        return !e;
    }

    return <>

        <Button variant="contained" onClick={toggleModal} {...buttonProps}>{label}</Button>
    
        <ModalForm open={openModal} loading={loading} onSubmit={handleSubmit} onClose={toggleModal} title='Inscription'>


            {error && <Alert severity='error'>{error}</Alert>}

            {!userId &&
                <TextField 
                    label="Utilisateur"
                    name="userId"
                    value={values.userId}
                    onChange={handleChange}
                    required={true}
                    disabled={users.length === 0}
                    helperText={users.length === 0 ? "Aucun utilisateur dans l'entreprise." : ''}
                    select
                    size='small'
                >
                    {users.map(u =>
                        <MenuItem value={u.id} key={u.id}>{u.name}{u.email ? ` (${u.email})` : ''}</MenuItem>    
                    )}
                </TextField>
            }

            <TextField 
                label="Formation"
                name="courseId"
                value={values.courseId}
                onChange={handleChange}
                required={true}
                disabled={courses.length === 0}
                helperText={courses.length === 0 ? "Aucune formation produite par l'entreprise." : ''}
                select
                size='small'
            >
                {courses.map(c =>
                    <MenuItem value={c.id} key={c.id}>{c.title}</MenuItem>    
                )}
            </TextField>

        </ModalForm>
    </>
}
